import Model from '@models/Model'
import Issue from "@models/Issue"

class FormResponse extends Model {
  constructor (initialData, included) {
    super(initialData, included, {
      columns: [
        'id',
        'relatable_type',
        'relatable_id',
        'topic',
        'category',
        'description',
        'aasm_state',
        'created_by_id',
        'closed_by_id',
        'closed_at',
        'created_at',
        'updated_at',
      ],
      dateKeys: [
        'created_at',
        'updated_at',
      ],
      relationships: {
        issues: { collection: true, model: Issue },
      },
    })
  }
}

export default FormResponse